import {
  FormSectionState,
  FormSectionStateArray,
  FormState,
  INITIAL_STATE_FIELD,
} from '@navstation-portal/reporting/data-model/vessel-report';
import {
  HoseHeatingOperationFormState,
  HoseOperationFormState,
} from '@navstation-portal/reporting/data-model/vessel-report';
import { signalStoreFeature, type } from '@ngrx/signals';
import { on, withReducer } from '@ngrx/signals/events';
import { cargoDetailsEvents } from './cargo-details-events';

const getHosesWithoutIndex = (hoses: FormSectionStateArray, index: number) => {
  return [...hoses.slice(0, index), ...hoses.slice(index + 1)];
};

const generateHoseOperation = () => {
  return {
    operationTimestamp: {
      ...INITIAL_STATE_FIELD,
      value: undefined,
    },
    ifo: {
      ...INITIAL_STATE_FIELD,
      value: undefined,
    },
    lsf: {
      ...INITIAL_STATE_FIELD,
      value: undefined,
    },
    lsg: {
      ...INITIAL_STATE_FIELD,
      value: undefined,
    },
    mgoOn: {
      ...INITIAL_STATE_FIELD,
      value: undefined,
    },
  } as HoseOperationFormState;
};

const generateHoseHeatingOperation = () => {
  return {
    comment: {
      ...INITIAL_STATE_FIELD,
      value: undefined,
    },
    ifo: {
      ...INITIAL_STATE_FIELD,
      value: undefined,
    },
    mgo: {
      ...INITIAL_STATE_FIELD,
      value: undefined,
    },
  } as HoseHeatingOperationFormState;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function withCargoDetailsReducer<_>() {
  return signalStoreFeature(
    type<{ state: { formState: FormState } }>(),
    withReducer(
      on(cargoDetailsEvents.addHoseOn, () => (state) => {
        const formState = state['formState'];
        const hoses = formState['hoses'] as FormSectionState;
        const hosesOn = (hoses['hosesOn'] as FormSectionStateArray) || [];
        return {
          formState: {
            ...formState,
            hoses: {
              ...hoses,
              hosesOn: [...hosesOn, generateHoseOperation()],
            },
          },
        };
      }),
      on(cargoDetailsEvents.removeHoseOn, ({ payload: index }) => (state) => {
        const formState = state['formState'];
        const hoses = formState['hoses'] as FormSectionState;
        const hosesOn = (hoses['hosesOn'] as FormSectionStateArray) || [];
        return {
          formState: {
            ...formState,
            hoses: {
              ...hoses,
              hosesOn: getHosesWithoutIndex(hosesOn, index),
            },
          },
        };
      }),
      on(cargoDetailsEvents.addHoseOff, () => (state) => {
        const formState = state['formState'];
        const hoses = formState['hoses'] as FormSectionState;
        const hosesOff = (hoses['hosesOff'] as FormSectionStateArray) || [];
        return {
          formState: {
            ...formState,
            hoses: {
              ...hoses,
              hosesOff: [...hosesOff, generateHoseOperation()],
            },
          },
        };
      }),
      on(cargoDetailsEvents.removeHoseOff, ({ payload: index }) => (state) => {
        const formState = state['formState'];
        const hoses = formState['hoses'] as FormSectionState;
        const hosesOff = (hoses['hosesOff'] as FormSectionStateArray) || [];
        return {
          formState: {
            ...formState,
            hoses: {
              ...hoses,
              hosesOff: getHosesWithoutIndex(hosesOff, index),
            },
          },
        };
      }),
      on(cargoDetailsEvents.addHeating, () => (state) => {
        const formState = state['formState'];
        const hoses = formState['hoses'] as FormSectionState;
        const heating = (hoses['heating'] as FormSectionStateArray) || [];
        return {
          formState: {
            ...formState,
            hoses: {
              ...hoses,
              heating: [...heating, generateHoseHeatingOperation()],
            },
          },
        };
      }),
      on(cargoDetailsEvents.removeHeating, ({ payload: index }) => (state) => {
        const formState = state['formState'];
        const hoses = formState['hoses'] as FormSectionState;
        const heating = (hoses['heating'] as FormSectionStateArray) || [];
        return {
          formState: {
            ...formState,
            hoses: {
              ...hoses,
              heating: getHosesWithoutIndex(heating, index),
            },
          },
        };
      })
    )
  );
}
